import { RangeItemList, RangeItemListClass } from './range-item.model';

export interface AsymetryVariableThresholds {
  impact: RangeItemList;
  pushOff: RangeItemList;
}

export class AsymetryVariableThresholdsClass
  implements AsymetryVariableThresholds
{
  impact: RangeItemList;
  pushOff: RangeItemList;

  constructor(o: any = {}) {
    this.impact = new RangeItemListClass(o['impact']);
    this.pushOff = new RangeItemListClass(o['pushOff']);
  }
}
